import { render } from "./SmallGifts.vue?vue&type=template&id=6d4f316c"
import script from "./SmallGifts.vue?vue&type=script&lang=js"
export * from "./SmallGifts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__